module.exports = __webpack_public_path__ + "img/3.bd2771c7.jpg";